import {boardMatrixExample, freeBetsStore, freeSpinStore, spinStore, store} from "../store";
import {
    handleSpinEnd,
    setSlotBoardCards,
    spinControlPanel,
} from "../slotBoard/spin";
import {showErrorToast} from "../notifications/toastNotificatons/toastNotification";
import {setSpinAmount} from "../controlPanel/betSettingsSection";
import {t} from "../translationService";
import {pixiComponents} from "../index";
import {hideTextWinFreeSpins, setBonusWinAmountBoardAmount, showBonusWinAmountBoard, startBonusGame} from "../freeSpin";
import {startAutoSpin} from "../controlPanel/autoSpin";
import {getAmountWithCurrency, shuffleMatrix} from "../utilites";
import {
    growWinAmountTo,
    setVisibleForSomeControlPanelItems,
    setWinAmountInfoTextInitial
} from "../controlPanel";
import {gsap} from "gsap";
import {multipliersNumsById} from "../constants/configs";
import {getFreeBets} from "../api";
import {freeBetGame} from "../freeBetGame";


export const spinErrorHandler = async (msg) => {
    await pixiComponents.slotBoard.cleanUpPromise;
    await pixiComponents.slotBoard.throw(shuffleMatrix(boardMatrixExample));
    spinStore.setWins([]);
    showErrorToast(t(msg));

    if (!store.isDemo()) {
        spinStore.setUserBalanceFromBackend();
    }

    pixiComponents.cpItems.stopSpinBtn.alpha = 1;

    handleSpinEnd();
}

export const spinResponseHandler = async (data) => {
    console.log(data)
    await pixiComponents.slotBoard.cleanUpPromise;
    const {items, amount, realBalance, freeSpin, winAmount} = data;

    if (freeSpin !== null && !freeSpinStore.isBonusGameStarted) {
        store.setLastWinAmount(0);
    }

    if (!freeSpin) {
        store.setLastWinAmount(0);
        setWinAmountInfoTextInitial();
    } else {
        setVisibleForSomeControlPanelItems(false);
    }
    spinStore.setExplodeSessions(items);

    pixiComponents.slotBoard.multipliersBoard.clean();
    await pixiComponents.slotBoard.throw(items[0].cards);

    for (let i = 0; i < items.length; i++) {
        if (items[i].winAmount > 0) {
            store.setLastWinAmount(store.lastWinAmount + items[i].winAmount)
            growWinAmountTo(store.lastWinAmount);
            pixiComponents.slotBoard.tumbleWinBoard.setAmount(pixiComponents.slotBoard.tumbleWinBoard.amount + items[i].winAmount);
            // if (freeSpin && freeSpinStore.isBonusGameStarted) {
            //     pixiComponents.slotBoard.tumbleWinBoard.setAmount(pixiComponents.slotBoard.tumbleWinBoard.amount + items[i].winAmount);
            // }
        }
        items[i].amount = amount;
        await pixiComponents.slotBoard.explodeSession(items[i]);
    }

    spinStore.setIsQuickFall(true);

    if (pixiComponents.slotBoard.tumbleWinBoard.amount) {
        const {multipliersBoard, tumbleWinBoard} = pixiComponents.slotBoard;

        await multipliersBoard.explosion();

        if (freeSpin) {
            if (multipliersBoard.totalMultiplayerComponent.totalMultiplier > 0 && tumbleWinBoard.multiplayer > 0) {
                await multipliersBoard.totalMultiplayerComponent.totalMultiplierAnimationToTumbleBoard();
                tumbleWinBoard.addMultiplayer(multipliersBoard.totalMultiplayerComponent.totalMultiplier);
                multipliersBoard.totalMultiplayerComponent.setTotalMultiplier(pixiComponents.slotBoard.tumbleWinBoard.multiplayer);
            } else if (tumbleWinBoard.multiplayer > 0) {
                multipliersBoard.totalMultiplayerComponent.setTotalMultiplier(pixiComponents.slotBoard.tumbleWinBoard.multiplayer);
            }
        }

        await gsap.delayedCall(0.3, () => {
        });
        await tumbleWinBoard.multiplyAmount();
        if (!freeSpin) {
            growWinAmountTo(tumbleWinBoard.amount);
        }
    }


    spinStore.setIsWonFreeSpin(freeSpin !== null && !freeSpinStore.isBonusGameStarted);

    if (freeSpin) {
        freeSpinStore.setFreeSpin(freeSpin);
        setVisibleForSomeControlPanelItems(false);
        pixiComponents.slotBoard.tumbleWinBoard.endTumbleSession();
        if (!spinStore.isWonFreeSpin) {
            store.setLastWinAmount(freeSpinStore.freeSpin.winAmount);
            growWinAmountTo(store.lastWinAmount);
        } else {
            growWinAmountTo(winAmount);
        }
    } else {
        spinStore.setUserBalance(realBalance);
    }

    if (freeSpin && store.maxOdd && freeSpin.odd >= store.maxOdd) {
        freeSpinStore.setIsBonusGameStarted(false);
    }

    if (spinStore.isWonFreeSpin) {
        spinStore.setAutoSpinCountdown(0)
    }

    handleSpinEnd();

    if (spinStore.isWonFreeSpin) {
        await pixiComponents.slotBoard.highlightIcon("scatter");
        startBonusGame();
    }
}

export const demoSpinResponseHandler = async (data) => {
    console.log(data);
    await pixiComponents.slotBoard.cleanUpPromise;
    const {items, winAmount, amount, freeSpin} = data;

    if(freeSpin !== null && !freeSpinStore.isBonusGameStarted){
        store.setLastWinAmount(0);
    }

    if (!freeSpin) {
        store.setLastWinAmount(0);
        setWinAmountInfoTextInitial();
    } else {
        setVisibleForSomeControlPanelItems(false);
    }
    spinStore.setExplodeSessions(items);
    pixiComponents.slotBoard.multipliersBoard.clean();
    await pixiComponents.slotBoard.throw(items[0].cards);

    for (let i = 0; i < items.length; i++) {
        if (items[i].winAmount > 0) {
            store.setLastWinAmount(store.lastWinAmount + items[i].winAmount)
            growWinAmountTo(store.lastWinAmount);
            pixiComponents.slotBoard.tumbleWinBoard.setAmount(pixiComponents.slotBoard.tumbleWinBoard.amount + items[i].winAmount);
            // if (freeSpin && freeSpinStore.isBonusGameStarted) {
            //     pixiComponents.slotBoard.tumbleWinBoard.setAmount(pixiComponents.slotBoard.tumbleWinBoard.amount + items[i].winAmount);
            // }
        }
        items[i].amount = amount;
        await pixiComponents.slotBoard.explodeSession(items[i]);
    }

    spinStore.setIsQuickFall(true);

    if (pixiComponents.slotBoard.tumbleWinBoard.amount) {
        const {multipliersBoard, tumbleWinBoard} = pixiComponents.slotBoard;

        await multipliersBoard.explosion();

        if (freeSpin) {
            if (multipliersBoard.totalMultiplayerComponent.totalMultiplier > 0 && tumbleWinBoard.multiplayer > 0) {
                await multipliersBoard.totalMultiplayerComponent.totalMultiplierAnimationToTumbleBoard();
                tumbleWinBoard.addMultiplayer(multipliersBoard.totalMultiplayerComponent.totalMultiplier);
                multipliersBoard.totalMultiplayerComponent.setTotalMultiplier(pixiComponents.slotBoard.tumbleWinBoard.multiplayer);
            } else if (tumbleWinBoard.multiplayer > 0) {
                multipliersBoard.totalMultiplayerComponent.setTotalMultiplier(pixiComponents.slotBoard.tumbleWinBoard.multiplayer);
            }
        }

        await gsap.delayedCall(0.2, () => {
        });
        await tumbleWinBoard.multiplyAmount();
        if (!freeSpin) {
            growWinAmountTo(tumbleWinBoard.amount);
        }
    }
    // handleSpinButton();
    // const {winAmount, betAmount, cards, wins, odd, freeSpin} = data;
    // console.log(data);
    // spinStore.setWins(wins);
    spinStore.setIsWonFreeSpin(freeSpin !== null && !freeSpinStore.isBonusGameStarted);


    if (freeSpin && !freeSpinStore.isBonusGameStarted) {
        freeSpinStore.setFreeSpin(freeSpin);
        setVisibleForSomeControlPanelItems(false);
    } else if (freeSpin) {
        let amount = 0;
        items.forEach(({winAmount}) => amount += winAmount);
        if (pixiComponents.slotBoard.tumbleWinBoard.multiplayer) {
            freeSpinStore.setBonusGameWinAmount(freeSpinStore.freeSpin.winAmount + (amount * pixiComponents.slotBoard.tumbleWinBoard.multiplayer - 1));
        } else {
            freeSpinStore.setBonusGameWinAmount(freeSpinStore.freeSpin.winAmount + winAmount);
        }
        freeSpinStore.setFreeSpinsUsedQuantity(freeSpinStore.freeSpin.usedQuantity + 1);
    }


    if (freeSpin) {
        setVisibleForSomeControlPanelItems(false);
        pixiComponents.slotBoard.tumbleWinBoard.endTumbleSession();
        if (!spinStore.isWonFreeSpin) {
            store.setLastWinAmount(freeSpinStore.freeSpin.winAmount);
            growWinAmountTo(store.lastWinAmount);
        } else {
            growWinAmountTo(winAmount);
        }
    } else {
        spinStore.setUserBalance(spinStore.userBalance + winAmount);
    }

    if (spinStore.isWonFreeSpin) {
        spinStore.setAutoSpinCountdown(0)
    }

    handleSpinEnd();

    if (spinStore.isWonFreeSpin) {
        await pixiComponents.slotBoard.highlightIcon("scatter");
        startBonusGame();
    }
}

export const initializeGameHandler = async (data) => {
    const {cards, lobbyEnabled, quickBets, sessionDurationSeconds, freeSpin, defaultBet, maxBet, maxOdd, maxWin, minBet} = data;
    store.setSessionDurationSeconds(sessionDurationSeconds);
    store.setLobbyEnabled(lobbyEnabled);
    store.setMaxBet(maxBet);
    store.setMaxOdd(maxOdd);
    store.setMaxWin(maxWin);
    store.setMinBet(minBet);
    spinStore.setQuickBets(quickBets);
    const defaultBetIndex = quickBets.findIndex(x => x === defaultBet) || 0;
    setSpinAmount(defaultBetIndex);
    setSlotBoardCards(cards);

    if (freeSpin && !store.isDemo()) {
        let totalMultiplier = freeSpin.multiplier;
        cards.forEach(reel => {
            reel.forEach(symbolId => {
                if (multipliersNumsById[symbolId]) {
                    totalMultiplier -= multipliersNumsById[symbolId];
                }
            })
        })
        pixiComponents.slotBoard.multipliersBoard.totalMultiplayerComponent.setTotalMultiplier(totalMultiplier);
        freeSpinStore.setFreeSpin(freeSpin);
        startBonusGame();
        hideTextWinFreeSpins();
        startAutoSpin(freeSpinStore.freeSpin.quantity - freeSpinStore.freeSpin.usedQuantity - 1);
        setBonusWinAmountBoardAmount(getAmountWithCurrency(freeSpin.winAmount, store.currency));
        freeSpin.winAmount && showBonusWinAmountBoard();
    } else if (!freeBetsStore.freeBet) {
        setSpinAmount(defaultBetIndex);
    }

    if (store.isDemo()) {
        spinStore.setUserBalance(100000);
    } else {
        spinStore.setUserBalanceFromBackend();
        const freeBetData = await getFreeBets(store.gameId);
        console.log(freeBetData);
        if (freeBetData.length && !freeSpin) {
            freeBetGame.startGame(freeBetData[0]);
        }
    }
}


export const freeBetAwardHandler = (data) => {
    if (store.isDemo()) {
        return;
    }
    if (freeSpinStore.freeSpin || freeSpinStore.isBonusGameStarted || spinControlPanel.isSpinning) {
        setTimeout(() => freeBetAwardHandler(data), 500);
        return;
    }
    if (data.gameIds.includes(store.gameId)) {
        freeBetGame.startGame(data)
    }
};

export const freeBetCountUpdateHandler = (data) => {
    if (store.isDemo()) {
        return;
    }
    freeBetGame.updateFreeBet(data);
}

export const freeBetEndHandler = (data) => {
    if (store.isDemo()) {
        return;
    }
    if (freeSpinStore.freeSpin || freeSpinStore.isBonusGameStarted || spinControlPanel.isSpinning) {
        setTimeout(() => freeBetEndHandler(data), 500);
        return;
    }
    freeBetGame.endGame(data);
}
